module.exports = __webpack_public_path__ + "static/media/blank.5bfd0143.svg";